import { render, staticRenderFns } from "./ReservationsStatsWeek.vue?vue&type=template&id=25d95ddb&"
import script from "./ReservationsStatsWeek.vue?vue&type=script&lang=js&"
export * from "./ReservationsStatsWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25d95ddb')) {
      api.createRecord('25d95ddb', component.options)
    } else {
      api.reload('25d95ddb', component.options)
    }
    module.hot.accept("./ReservationsStatsWeek.vue?vue&type=template&id=25d95ddb&", function () {
      api.rerender('25d95ddb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/accounts/ReservationsStatsWeek.vue"
export default component.exports